<div class="content-container">
    <div class="footer-row">
        <ul class="single-column">
            <li><a href="http://www.hhs.gov" target="_blank" rel="noopener noreferrer">U.S. Department of Health &amp; Human Services</a></li>
            <li><a href="http://www.nih.gov" target="_blank" rel="noopener noreferrer">National Institutes of Health</a></li>
        </ul>
    </div>
    <div class="footer-row">
        <ul class="single-row">
            <li><a href="https://www.hhs.gov/vulnerability-disclosure-policy/index.html" target="_blank" rel="noopener noreferrer">HHS Vulnerability Disclosure</a></li>
            <li>|</li>
            <li><a href="http://www.ncats.nih.gov/">NCATS Home</a></li>
            <li>|</li>
            <li><a href="http://www.nih.gov/about/access.htm" target="_blank" rel="noopener noreferrer">Accessibility</a></li>
            <li>|</li>
            <li><a href="./privacy.html">Privacy Notice</a></li>
            <li>|</li>
            <li><a href="./licensing.html">Licensing</a></li>
            <li>|</li>
            <li><a href="http://www.ncats.nih.gov/about/foia.html">FOIA</a></li>
            <li>|</li>
            <li><a href="http://oig.hhs.gov/" target="_blank" rel="noopener noreferrer">OIG</a></li>   
        </ul>
    </div>
    <div class="footer-row">
        <ul class="single-column">
            <li>National Center for Advancing Translational Sciences (NCATS), 6701 Democracy Boulevard, Bethesda MD 20892-4874 | 301-435-0888</li>
        </ul>
    </div>
</div>